// Temporary, while ${({ $gradient }) => $gradient && gradientBgCss} keeps giving type error.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import styled, { css } from "styled-components";
import { Button as AntdButton, ButtonProps as AntdButtonProps } from "antd";

type StyledButtonProps = AntdButtonProps & {
  $gradient: boolean;
};

const gradientBgCss = css<StyledButtonProps>`
  &.ant-btn-primary {
    background-image: ${({ theme }) =>
      `linear-gradient(to right, ${theme.token.colorPrimaryBg} -15%, ${theme.token.colorPrimary} 40%)`};
    z-index: 1;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: ${({ theme }) => theme.token.colorPrimaryHover};
      z-index: -1;
      transition: ${({ theme }) =>
        `opacity ${theme.token.motionDurationMid} linear`};
      opacity: 0;
    }

    &:not(:disabled):hover {
      &::before {
        opacity: 1;
      }
    }
  }
`;

export const StyledButton = styled(AntdButton)<StyledButtonProps>`
  &:not(.ant-btn-background-ghost):not(.ant-btn-default):not(.ant-btn-primary) {
    border-width: 0;
  }

  /* type="gradient" */
  ${({ $gradient }) => $gradient && gradientBgCss}

  /* Fix for block buttons with custom size */
  &.ant-btn:not(.ant-btn-icon-only) {
    &.ant-btn-lg,
    &.ant-btn-sm {
      width: ${({ block }) => (block ? "100%" : "auto")};
    }
  }
`;
